import React, { useState } from 'react';
import { downloadStaffNotesPdf, fetchStaffNotes, STAFF_NOTES_TITLE } from '../../utils/staffNotes';
import './StaffNotes.css';

/**
 * The download on every admin page. Rendered by PrivateRoute so that a new
 * admin page gets it without anyone having to remember. Always fetches first,
 * so a printed copy is never older than the latest save.
 */
const StaffNotesDownload: React.FC = () => {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    setBusy(true);
    try {
      await downloadStaffNotesPdf(await fetchStaffNotes());
    } catch {
      alert('Could not download the staff notes. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className="staff-notes-download"
      onClick={handleClick}
      disabled={busy}
      title={`Download ${STAFF_NOTES_TITLE} (PDF)`}
    >
      {busy ? 'Preparing…' : '📄 Safety Rules and Closing Protocol'}
    </button>
  );
};

export default StaffNotesDownload;
